
export class Country {
  constructor(public id: number,
              public name: string,
              public cd: string) { }
}




// WEBPACK FOOTER //
// ./src/app/shared/model/country.ts